import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight, Cpu, Globe, Zap } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full min-h-[90vh] flex items-center justify-center overflow-hidden bg-slate-950 text-white pt-20" data-id="element-27">
      {/* Abstract Technical Background */}
      <div className="absolute inset-0 z-0 opacity-20" data-id="element-28">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]" data-id="element-29"></div>
        <div className="absolute left-0 right-0 top-0 -z-10 m-auto h-[310px] w-[310px] rounded-full bg-cyan-500 opacity-20 blur-[100px]" data-id="element-30"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-31">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-32">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-33">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.2,
            duration: 0.5
          }} className="inline-flex items-center space-x-2 bg-slate-900/50 border border-slate-800 rounded-full px-3 py-1 mb-6" data-id="element-34">
              <span className="flex h-2 w-2 rounded-full bg-cyan-500 animate-pulse" data-id="element-35"></span>
              <span className="text-sm text-slate-300 font-medium" data-id="element-36">
                Reimagining Consumer Tech
              </span>
            </motion.div>

            <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-6 leading-tight" data-id="element-37">
              Building Tomorrow's <br data-id="element-38" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500" data-id="element-39">
                Consumer Apps
              </span>
              , Today
            </h1>

            <p className="text-lg md:text-xl text-slate-400 mb-8 leading-relaxed max-w-lg" data-id="element-40">
              Remote Systems develops innovative software solutions that
              transform how people interact with technology. We build
              proprietary products that solve real problems.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-41">
              <Button size="lg" className="group" data-id="element-42">
                View Our Products
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-43" />
              </Button>
              <Button variant="secondary" size="lg" data-id="element-44">
                Learn About Us
              </Button>
            </div>
          </motion.div>

          {/* Abstract Visual Representation */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.3,
          duration: 0.7
        }} className="relative hidden lg:block" data-id="element-45">
            <div className="relative w-full aspect-square max-w-md mx-auto" data-id="element-46">
              {/* Central Hub */}
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-47">
                <div className="w-32 h-32 bg-slate-900 border-2 border-cyan-500/30 rounded-2xl flex items-center justify-center shadow-[0_0_50px_-12px_rgba(6,182,212,0.3)] z-20" data-id="element-48">
                  <Globe className="w-16 h-16 text-cyan-500" data-id="element-49" />
                </div>
              </div>

              {/* Floating Elements */}
              <motion.div animate={{
              y: [0, -10, 0]
            }} transition={{
              repeat: Infinity,
              duration: 4,
              ease: 'easeInOut'
            }} className="absolute top-10 left-10 p-4 bg-slate-900 border border-slate-800 rounded-xl shadow-xl z-10" data-id="element-50">
                <Cpu className="w-8 h-8 text-blue-400" data-id="element-51" />
              </motion.div>

              <motion.div animate={{
              y: [0, 10, 0]
            }} transition={{
              repeat: Infinity,
              duration: 5,
              ease: 'easeInOut',
              delay: 1
            }} className="absolute bottom-20 right-10 p-4 bg-slate-900 border border-slate-800 rounded-xl shadow-xl z-10" data-id="element-52">
                <Zap className="w-8 h-8 text-yellow-400" data-id="element-53" />
              </motion.div>

              {/* Connecting Lines (SVG) */}
              <svg className="absolute inset-0 w-full h-full pointer-events-none opacity-30" data-id="element-54">
                <line x1="50%" y1="50%" x2="20%" y2="20%" stroke="currentColor" strokeWidth="1" className="text-cyan-500" data-id="element-55" />
                <line x1="50%" y1="50%" x2="80%" y2="70%" stroke="currentColor" strokeWidth="1" className="text-cyan-500" data-id="element-56" />
              </svg>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}